import { GET_SHOP_FEATURES_QUERY, GetShopFeaturesResponse, SHOP_FEATURES_API_VERSION } from '../queries';
import { useShopifyGraphQLSWR } from '../useShopifyGraphQLSWR';

/**
 * The shop's Shopify feature flags (`shop.features`), e.g. whether market-driven shipping is enabled
 * on the Shopify side.
 */
export const useShopFeaturesSWR = ({
    enabled = true,
}: { /** Set to false to skip the request. */ enabled?: boolean } = {}) => {
    const { data, error, isLoading, mutate } = useShopifyGraphQLSWR<GetShopFeaturesResponse>(
        enabled ? 'shopify-shop-features' : null,
        GET_SHOP_FEATURES_QUERY,
        undefined,
        'shop',
        { version: SHOP_FEATURES_API_VERSION }
    );

    return {
        /** `undefined` until loaded, so callers can tell "not enabled" from "not known yet". */
        isMarketDrivenShippingEnabled: data?.shop?.features?.marketDrivenShipping,
        error,
        isLoading,
        mutate,
    };
};
